export * from './account'
export * from './contract'
export * from './mint'

import EthereumNetwork from '@providers/EthereumNetwork'
import PolygonNetwork from '@providers/PolygonNetwork'
import { IAbiItem } from '@types'

export const handleGetRemainedTokenCount = async (
    provider: EthereumNetwork | PolygonNetwork,
    contractAbi: IAbiItem[],
    contractAddress: string,
): Promise<number> => {
    return await provider.getWeb3Contract(contractAbi, contractAddress).methods.tokenIdCounter().call()
}
